import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { FilterCommonProps } from '../types';
import { OptionsType } from 'ui/common/select/types';

export class FilterCodeFlat extends React.Component<FilterCommonProps, {}> {

  public render() {
    const {
      optionsEndpoint,
      optionsParams,
      simpleFormComponent: SimpleForm,
      initialValue,
      translation,
      filterDomain: { id: name },
      filterDomain,
      categoryOptionsEndpoint,
      displayCategories,
      categoryOptionsParams
    } = this.props;

    return <SimpleForm
      name={name}
      type={FIELD_TYPE.SELECT_MULTIPLE}
      initialValue={initialValue}
      optionsEndpoint={optionsEndpoint}
      categoryOptionsEndpoint={categoryOptionsEndpoint}
      placeholder={translation && translation.filters_search_placeholder}
      translation={translation}
      optionsParams={optionsParams}
      optionsDisplaySetting={OptionsType.flat}
      displayCategories={displayCategories}
      categoryOptionsParams={categoryOptionsParams}
      displayDisabledLabel={filterDomain.hasDisabledColumn && translation.include_disabled}
      hasDisabledColumn={filterDomain.hasDisabledColumn}
    />;
  }
}
